import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { useAuthUser } from '../../api';
import { useSuspenseFeatureAccess } from '../../api/hooks/workspace/useSuspenseFeatureAccess';
import { useUpdateWorkspace } from '../../api/hooks/workspace/useUpdateWorkspace';
import { EmptyState } from '../EmptyState';
import { UpgradeButton } from './UpgradeButton';

export function AutomationSettings() {
	const { workspace } = useAuthUser();
	const { mutateAsync: updateWorkspace } = useUpdateWorkspace(workspace.id);
	const { automationsAccess } = useSuspenseFeatureAccess();

	if (!automationsAccess) {
		return (
			<EmptyState
				title="Upgrade to access automations"
				description="Automatically set tags, owners, property values, and so much more with automations."
				illustrationName="upgrade"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
				withActions={<UpgradeButton feature="Automations" size="md" />}
			/>
		);
	}

	return (
		<Stack>
			<Box>
				<SettingsSwitch
					onChange={(checked) =>
						updateWorkspace({
							data: { id: workspace.id, automation_enabled: checked },
						})
					}
					checked={workspace?.automation_enabled ?? false}
					title="Automations"
					description="Turn on automations for this workspace"
				/>
			</Box>
		</Stack>
	);
}
